import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import getProgressBarColor from '../../Utils/getProgressBarColor';
import DescriptionBanner from '../DescriptionBanner';
import TotalsSummaryCard from '../TotalSummaryCard';
import DynamicTable from '../UI/DynamicTable';


export default function FileAngelTable({
    fileAngelStats,
    isVisibleTotValue = true,
    viewDescriptionBanner = true,
    disableForEnterprise
}) {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const filteredData = fileAngelStats?.endpoint_stats.filter((item) => {
        const lowerCaseSearch = search.toLowerCase();
        const matchesSearch = (item.email ?? '').toLowerCase().includes(lowerCaseSearch)
        return matchesSearch
    });
    const totalValue = [
        {
            label: t('totalEndpoints'),
            value: fileAngelStats?.company_stats.total_endpoints ?? 0
        },
        {
            label: t('totalFilesExamined'),
            value: fileAngelStats?.company_stats.total_files_examined ?? 0
        },
        {
            label: t('totalMalwareFiles'),
            value: fileAngelStats?.company_stats.malware_files ?? 0
        },
        {
            label: t('avgMalwareRate'),
            value: `${fileAngelStats?.company_stats.malware_rate_avg ?? 0}`,
            "suffix": '%'
        }
    ];


    return (
        <div>

            {viewDescriptionBanner ?
                <div className='mb-6'>
                    <DescriptionBanner title={t('fileAngelStatus')} description={t('fileAngelStatusDesc')} />
                </div> : null
            }

            {isVisibleTotValue ? <TotalsSummaryCard items={totalValue} /> : null}

            {!disableForEnterprise && (
                <div className='mt-6'>
                    {filteredData && filteredData.length > 0 ? (
                        <DynamicTable
                            data={filteredData}
                            customColumnsMap={[
                                {
                                    field: 'email',
                                    label: t('email'),
                                    width: 'w-48'
                                },
                                {
                                    field: 'total_files',
                                    label: t('filesExamined'),
                                    width: 'w-48'
                                },
                                {
                                    field: 'malware_files',
                                    label: t('malwareFiles'),
                                    width: 'w-48'
                                },
                                {
                                    label: t('malwareRate'),
                                    width: 'w-48',
                                    align: 'left',
                                    render: (row) => (
                                        <div className="flex gap-2 items-center">
                                            <div>
                                                {row.malware_rate}%
                                            </div>
                                            <div className="w-full gap-2 bg-gray-300 h-3 rounded">
                                                <div
                                                    className={`${getProgressBarColor(row.malware_rate)} h-3 rounded`}
                                                    style={{ width: `${row.malware_rate || 0}%` }}
                                                ></div>
                                            </div>
                                        </div>
                                    )
                                },
                            ]}
                            searchTerm={search}
                            onSearchChange={setSearch}
                            searchKeys={['asset', 'tipo_asset']}
                            enableRowSelection={false}
                            showSearchBar={true}
                            maxHeight="40rem"
                        />
                    ) : (
                        <div className='text-center py-8 text-gray-500'>
                            Nessun dato disponibile da caricare in questa sezione
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}